<div class="interactions-form-host">
  <app-simulation-form-shell>

    <div class="left-column" simulation-left>
      <div class="header-left">
        <button class="back-button" (click)="onBack()" [title]="'BUTTON.BACK' | translate">
          <fa-icon [icon]="faArrowLeft"></fa-icon>
        </button>
        <div class="interaction-name">
          {{ interactionName }}
        </div>
      </div>
      <app-assistant-trigger
        titleKey="ASSISTANT.BUTTON_TITLE"
        (triggered)="onOpenAssistant()">
      </app-assistant-trigger>

      <div class="file-select-wrapper">
        <div class="file-select-header">
          <label>{{ 'INTERACTIONS.FILES_SELECTED' | translate: { count: archives.length } }}</label>

          <button class="manage-files-btn" (click)="onOpenFileManager()">
            <fa-icon [icon]="faFolderOpen"></fa-icon>
            <span>{{ 'INTERACTIONS.MANAGE_FILES' | translate }}</span>
          </button>
        </div>

        <div class="file-select-row">
          <ng-select class="file-select" [items]="archives" bindLabel="name" bindValue="id" [ngModel]="selectedFile"
            (ngModelChange)="onFileChanged($event)" [notFoundText]="'NG_SELECT.NO_ITEMS_FOUND' | translate"
            [clearable]="false" [searchable]="true">
            <ng-template ng-label-tmp let-item="item">
              <span [title]="item.name">{{ item.name | truncateMiddle:30 }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span [title]="item.name">{{ item.name | truncateMiddle:30 }}</span>
            </ng-template>
          </ng-select>

          @if (userPreferences?.show_advanced_options) {
          <button class="manage-groups-btn" (click)="onOpenFileGroupsModal()"
            [title]="'INTERACTIONS.MANAGE_GROUPS' | translate">
            <fa-icon [icon]="faLayerGroup"></fa-icon>
          </button>
          }
        </div>
      </div>

      <div class="file-viewer">
        @if (archives.length) {
        <app-viewer [images]="imageUrls" [imgIndex]="viewerImgIndex"
          [numOfPages]="previewMetadata?.totalPages || imageUrls.length" [loading]="previewBatchLoading"
          (changeImgIndex)="onViewerPageChange($event)">
        </app-viewer>
        } @else {
        <div class="viewer-empty">
          <fa-icon [icon]="faFolderOpen" class="viewer-empty-icon"></fa-icon>
          <p>{{ 'INTERACTIONS.NO_FILES_HINT' | translate }}</p>
        </div>
        }
      </div>
    </div>

    <div class="right-column" simulation-right>

      <app-tabs [tabs]="mainTabs" [(activeId)]="activeMainTabId" variant="underline" [fullWidth]="true"
        (helpClicked)="onHelpClicked($event)">
      </app-tabs>

      <div class="tab-content">

        @if (activeMainTabId === 'edit') {
        <app-interaction-model-editor [models]="modelsByType" [selectedModel]="selectedModelId"
          (selectedModelChange)="onSelectedModelChange($event)" [modelTabs]="modelTabs"
          [activeModelTabId]="activeModelTabId" (activeModelTabIdChange)="activeModelTabId = $event"
          [basicUserListInitial]="basicUserListInitial" [generalRulesInitial]="generalRulesInitial"
          [generalQuestionsInitial]="generalQuestionsInitial" [basicUserList]="basicUserList"
          [generalRulesData]="generalRulesData" [generalQuestionsData]="generalQuestionsData"
          [mentionData]="mentionData" [(newModelName)]="newModelName" [hasChanges]="hasChanges"
          [archivesCount]="archives.length"
          [allReferences]="allReferences" [selectedReferences]="selectedReferencesIds" (importModel)="onImportModel()"
          (exportModel)="onExportModel()" (saveOnly)="onSaveOnly()" (saveAndExecute)="onSaveAndExecute()"
          (execute)="onExecute()" (mentionDataChange)="onMentionDataChange($event)"
          (basicFormChange)="onBasicFormChange($event)" (rulesFormChange)="onRulesFormChange($event)"
          (questionsFormChange)="onQuestionsFormChange($event)" (referencesChange)="onReferencesChange($event)"
          (modelHelpClicked)="onModelHelpClicked($event)"
          [selectedModelType]="selectedModelType" [classificationInitial]="classificationInitial"
          (classificationFormChange)="onClassificationFormChange($event)"
          (deleteModel)="onRequestDeleteModel($event)">
        </app-interaction-model-editor>
        }

        @if (activeMainTabId === 'results') {
        <app-interaction-results [interactionId]="interactionId" [loadingResults]="loadingResults" [results]="results"
          [isTabActive]="activeMainTabId === 'results'" (refreshResults)="loadResults()">
        </app-interaction-results>
        }

      </div>

    </div>

  </app-simulation-form-shell>

  @if (showModal) {
  <app-modal-interaction-archives-add [show]="showModal" [interactionId]="interactionId" (close)="closeModal()">
  </app-modal-interaction-archives-add>
  }

  @if (showFileGroupsModal) {
  <app-modal-file-groups [show]="showFileGroupsModal" [interactionId]="interactionId" [archives]="archives"
    (close)="onCloseFileGroupsModal()" (groupsChanged)="onFileGroupsChanged($event)">
  </app-modal-file-groups>
  }

  <app-modal-execute-interaction [show]="showExecuteModal" [initialOptions]="executionOptions"
    [hasReferences]="selectedReferencesIds.length > 0" [delfosServerConfigs]="delfosServerConfigs"
    [delfosLlmConfigs]="delfosLlmConfigs" [di2winocrServerConfigs]="di2winocrServerConfigs"
    [di2winocrFeaturesConfigs]="di2winocrFeaturesConfigs" [fileGroups]="fileGroups" [archives]="archives"
    (close)="onCloseExecuteModal()"
    (confirm)="onConfirmExecute($event)">
  </app-modal-execute-interaction>

  <app-modal-help [show]="showHelpModal" [title]="helpModalTitle" [content]="helpModalContent"
    (close)="onCloseHelpModal()">
  </app-modal-help>

  <app-modal-confirm [show]="showLeaveModal" title="COMMON.UNSAVED_TITLE" message="COMMON.UNSAVED_MESSAGE"
    confirmLabel="COMMON.LEAVE" variant="warning" btnVariant="danger" (close)="onLeaveCancel()"
    (confirm)="onLeaveConfirm()">
  </app-modal-confirm>

  <app-modal-delete-confirm [show]="showDeleteModelModal" [configKey]="modelToDelete?.name || ''"
    [configType]="'SECTION.MODELS' | translate" [impactItems]="modelDeleteImpactItems"
    [forceCheckboxLabel]="modelDeleteForceLabel" [forceCheckboxWarning]="modelDeleteForceWarning"
    (close)="onDeleteModelClose()" (confirm)="onDeleteModelConfirm($event)">
  </app-modal-delete-confirm>

  @if (showAssistant) {
  <app-chat-assistant [loading]="loadingAssistant" [archives]="archives" [selectedArchiveId]="selectedFile"
    [modelType]="selectedModelType" [ocrFeaturesConfigs]="di2winocrFeaturesConfigs"
    [selectedOcrFeaturesId]="selectedDi2winocrFeatures"
    [delfosLlmConfigs]="delfosLlmConfigs" [selectedDelfosLlmId]="selectedDelfosLlm"
    (chatResult)="onAssistantResult($event)" (closeChat)="onCloseAssistant()">
  </app-chat-assistant>
  }

</div>